import can from 'can';
import template from './alert.stache';
import 'dotdotdot';
import _ from 'lodash';

import { sendClickAnalytics } from './alert.controller';

const ALERT_DURATION = 10 * 1000;

export default can.Component.extend({
    tag: 'alert-manager-alert',
    template,
    viewModel: {
        define: {
            player: {
                type: 'object',
                value: null,
            },
            playersList: {
                type: 'array',
                value: [],
            },
            alert: {
                type: 'object',
                value: null,
            },
            isVisible: {
                type: 'boolean',
                value: false,
            },
        },
    },
    events: {
        inserted() {
            this.createListeners();
        },
        createListeners() {
            this.viewModel.bind('alert', (ev, value) => {
                if (!value) {
                    return;
                }

                this.element
                    .find('.c-alert__text')
                    .text(`${value.text}`)
                    .dotdotdot({
                        height: 40,
                        watch: true,
                    });

                this.showAlert();
                this.viewModel.attr('live', value.live);
            });
        },
        showAlert() {
            this.viewModel.attr('isVisible', true);
            this.alertTimeout = setTimeout(
                this.hideAlert.bind(this),
                ALERT_DURATION,
            );
        },
        hideAlert() {
            clearTimeout(this.alertTimeout);
            this.alertTimeout = null;
            this.viewModel.attr('isVisible', false);
            this.viewModel.dispatch('onAlertHide');
        },

        '.js-close-button click'() {
            if (this.alertTimeout) {
                clearTimeout(this.alertTimeout);
            }

            this.viewModel.dispatch('onCloseClick');
        },

        '.js-cta-link click'() {
            const alert = this.viewModel.attr('alert');

            if (!alert) {
                return;
            }

            sendClickAnalytics(alert);
            window.open(_.get(alert, 'button.url'), '_blank');
        },
    },
});
